export default function Step5() {
    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.7617 14.0527H37.494C38.878 14.0527 39.9999 15.1747 39.9999 16.5587C39.9999 16.7955 39.9664 17.0312 39.9002 17.2586L35.8907 31.0412C35.5794 32.1113 34.5989 32.8472 33.4845 32.8472H18.11C16.9956 32.8472 16.0151 32.1113 15.7038 31.0412L10.7617 14.0527Z"
                stroke="#010101"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <path d="M11.5178 16.5588L10.1124 12.0536C9.7859 11.0069 8.81672 10.2939 7.7202 10.2939H4" stroke="#010101" strokeWidth="3" strokeLinecap="round" />
            <path
                d="M18 40.2939C19.1046 40.2939 20 39.3985 20 38.2939C20 37.1894 19.1046 36.2939 18 36.2939C16.8954 36.2939 16 37.1894 16 38.2939C16 39.3985 16.8954 40.2939 18 40.2939Z"
                fill="#010101"
            />
            <path
                d="M34 40.2939C35.1046 40.2939 36 39.3985 36 38.2939C36 37.1894 35.1046 36.2939 34 36.2939C32.8954 36.2939 32 37.1894 32 38.2939C32 39.3985 32.8954 40.2939 34 40.2939Z"
                fill="#010101"
            />
            <path d="M20.7852 20.3408V26.6104" stroke="#010101" strokeWidth="2.4" strokeLinecap="round" />
            <path d="M25.7969 20.3408V26.6104" stroke="#010101" strokeWidth="2.4" strokeLinecap="round" />
            <path d="M30.8086 20.3408V26.6104" stroke="#010101" strokeWidth="2.4" strokeLinecap="round" />
        </svg>
    );
}
